import { render, staticRenderFns } from "./AdminExtraHeader.vue?vue&type=template&id=12b0e9c1&"
import script from "./AdminExtraHeader.vue?vue&type=script&lang=js&"
export * from "./AdminExtraHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminExtraHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports